import React from 'react';
import PropTypes from 'prop-types';

function TabPanel({ id, active, idPrefix, children }) {
  return (
    <div
      role="tabpanel"
      id={`${idPrefix}-tabpanel-${id}`}
      aria-labelledby={`${idPrefix}-tab-${id}`}
      hidden={id !== active}
    >
      {children}
    </div>
  );
}

TabPanel.propTypes = {
  id: PropTypes.string.isRequired,
  active: PropTypes.string.isRequired,
  idPrefix: PropTypes.string.isRequired,
  children: PropTypes.node
};

TabPanel.defaultProps = {
  children: null
};

export default TabPanel;
